import { getConfig } from '@configs/envConfig'
import { HTTPRequestMethods } from '@enums/HTTPRequestMethods'
import { errorWithStack } from '@utils/logger'

const getSearchBaseUrl = (ackoDriveBaseUrl?: string) =>
  `${ackoDriveBaseUrl || getConfig(process.env.ACKO_ENV)?.ackoDriveBaseUrl}/api/catalog-proxy/rest/v1`

export const searchCars = async (query: string, cityName: string, ackoDriveBaseUrl?: string) => {
  try {
    const baseURL = getSearchBaseUrl(ackoDriveBaseUrl)
    const url = `${baseURL}/search/?query=${encodeURIComponent(query)}&cityName=${encodeURIComponent(cityName)}`

    const response = await fetch(url, {
      method: HTTPRequestMethods.GET,
      headers: {
        'Content-Type': 'application/json',
      },
    })

    if (!response.ok) {
      throw new Error(`API request failed: ${response.status}`)
    }

    const data = await response.json()
    return data
  } catch (error) {
    errorWithStack('Error fetching cars search:', error)
    return []
  }
}

export const searchBlogs = async (query: string, ackoDriveBaseUrl?: string) => {
  try {
    const baseURL = getSearchBaseUrl(ackoDriveBaseUrl)
    let url = `${baseURL}/search/articles/`

    if (query?.trim()) {
      url += `?query=${encodeURIComponent(query)}`
    }

    const response = await fetch(url, {
      method: HTTPRequestMethods.GET,
      headers: {
        'Content-Type': 'application/json',
      },
    })

    if (!response.ok) {
      throw new Error(`API request failed: ${response.status}`)
    }

    const data = await response.json()
    return data
  } catch (error) {
    errorWithStack('Error searching blogs:', error)
    return []
  }
}
